import { useCallback, useRef } from 'react';

export const useHiddenEditorTransition = (onSettledReveal: () => void) => {
  const pendingTransitionIndicesRef = useRef<number[]>([]);
  const revealAfterTransitionRef = useRef(false);
  const onSettledRevealRef = useRef(onSettledReveal);
  onSettledRevealRef.current = onSettledReveal;

  const startTransition = useCallback((targetIndex: number) => {
    pendingTransitionIndicesRef.current.push(targetIndex);
  }, []);

  const handleTransitionSettled = useCallback((settledIndex: number) => {
    if (settledIndex !== pendingTransitionIndicesRef.current[0]) {
      return;
    }

    pendingTransitionIndicesRef.current.shift();
    if (pendingTransitionIndicesRef.current.length === 0 && revealAfterTransitionRef.current) {
      revealAfterTransitionRef.current = false;
      onSettledRevealRef.current();
    }
  }, []);

  const waitForTransition = useCallback((): boolean => {
    if (pendingTransitionIndicesRef.current.length === 0) {
      return false;
    }

    revealAfterTransitionRef.current = true;
    return true;
  }, []);

  return { handleTransitionSettled, startTransition, waitForTransition };
};
